import { useEffect } from "react";
import api from "src/store/features/api";
import {
  setIgnoreBiometrics,
  setIgnoreFileUpload,
  useOnboarding,
} from "src/store/features/onboarding.slice";
import { useUserSlice } from "src/store/features/user.slice";
import { useAppDispatch } from "src/store/store";

export default function useIgnoreBiometrics() {
  const { data: isKycExpired = true, isLoading: isKycExpirationLoading } =
    api.useIsKycExpiredByEmailQuery();
  const { data: isDocumentExpired, isLoading: isDocumentExpirationLoading } =
    api.useIsDocumentExpiredQuery();
  const { ignoreBiometrics, ignoreFileUpload } = useOnboarding();

  const { details: customerId } = useUserSlice();

  const isVerificationLoading = isKycExpirationLoading || isDocumentExpirationLoading;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isVerificationLoading) {
      // If it's not KYC Expired ignore biometrics
      if (!isKycExpired) {
        console.warn(
          `isKycExpired is false User with customer ID ${customerId} is ignoring biometrics`,
        );
        dispatch(setIgnoreBiometrics(true));
      }
      // If document is not expired ignore file upload
      if (!isDocumentExpired) dispatch(setIgnoreFileUpload(true));
    }
  }, [isKycExpired, isDocumentExpired, isVerificationLoading]);

  return [ignoreBiometrics, ignoreFileUpload, isVerificationLoading];
}
